import { render, staticRenderFns } from "./parameter-template.vue?vue&type=template&id=4cb7da26&scoped=true&lang=pug&"
import script from "./parameter-template.vue?vue&type=script&lang=ts&"
export * from "./parameter-template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb7da26",
  null
  
)

export default component.exports